export class FeatureFlag {
  id: string;
  name: string;
  enabled: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.enabled = data.enabled;
  }
}
